import React from 'react'
import GuestPrivilegeModal from './GuestPrivilegeModal'
import { fetchRecentlyServiceTxns } from '../../actions/remote_api'
import { connect } from 'react-redux'
import { info } from '../../storage'
import { useGuestPrivilege } from '../../actions/checkin'

class GuestPrivilegeModalContainer extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (!this.props.isShow && nextProps.isShow) {
      const { serviceId, stationId } = info()
      this.props.fetchRecentlyServiceTxns({ serviceId, stationId })
    }
  }

  handleServiceTxnClick = (serviceTxn) => {
    this.props.useGuestPrivilege(serviceTxn)
    this.props.onHide()
    if (this.props.onGuestSelected) this.props.onGuestSelected()
  }

  render() {
    return (
      <GuestPrivilegeModal
        isShow={this.props.isShow}
        onHide={this.props.onHide}
        recentlyServiceTxns={this.props.recentlyServiceTxns}
        onServiceTxnClick={this.handleServiceTxnClick}
      />
    )
  }
}

export default connect(
  ({ fetch: { recentlyServiceTxn } }) => ({
    recentlyServiceTxns:
      recentlyServiceTxn && recentlyServiceTxn.list
        ? recentlyServiceTxn.list
        : undefined,
  }),
  { fetchRecentlyServiceTxns, useGuestPrivilege },
)(GuestPrivilegeModalContainer)
